import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/lingo/DashboardLayout";
import api from "@/lib/api";

export default function FinanceDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/billing/finance/summary").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <DashboardLayout title="Finance"><div className="text-slate-400">You need finance/admin role to view this.</div></DashboardLayout>;
  return (
    <DashboardLayout title="Finance">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {[
          ["Total users", s.total_users],
          ["Active subscriptions", s.active_subscriptions],
          ["Trial bookings", s.trial_bookings],
          ["Est. MRR ($)", s.monthly_recurring_revenue_estimate_usd],
        ].map(([l, v]) => (
          <div key={l} className="bg-white border border-slate-200 rounded-2xl p-6">
            <div className="text-xs uppercase tracking-widest text-slate-400">{l}</div>
            <div className="font-display text-4xl mt-2">{v}</div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
